export function serializePersistenceKey(primaryKey, input) {
    if (typeof primaryKey === 'string') {
        if (typeof input !== 'string') {
            throw new Error(`Persistence key for field primary key "${primaryKey}" must be a string`);
        }
        return input;
    }
    if (typeof input === 'string') {
        throw new Error(`Persistence key for composite primary key "${primaryKey.key}" must be an object`);
    }
    return primaryKey.fields.map((field) => input[field]).join(primaryKey.separator);
}
